/** Task 7.16 registrations (the share-management toolbar entries) — side effects only. */
import { registerStorageShareToolbarExtensions } from './shareToolbarExtensions';

registerStorageShareToolbarExtensions();
